import { CosmosText, CosmosTitle } from "@cosmos/web-react";
import classNames from "classnames/bind";
import styles from "./KnowledgeCard.module.css";

const cx = classNames.bind(styles);

export function KnowledgeCard({
  title,
  kicker,
  imageUrl,
  linkUrl,
}: {
  title: string;
  kicker: string;
  imageUrl: string;
  linkUrl?: string;
}) {
  return (
    <div className={cx("container")}>
      <div className={cx("header")}>
        <CosmosTitle size="xx-small" weight="bold" appearance="dark">
          {linkUrl ? (
            <a href={linkUrl} className={cx("link")}>
              {title}
            </a>
          ) : (
            title
          )}
        </CosmosTitle>
        <CosmosText
          size="xx-small"
          weight="medium"
          kind="subtle"
          appearance="dark"
          className={cx("kicker")}
        >
          {kicker}
        </CosmosText>
      </div>
      <div className={cx("media")}>
        <img src={imageUrl} alt="" className={cx("image")} />
      </div>
    </div>
  );
}
